define('InternalFormView',['backbone', 'jquery', 'router', 'site_vars'], function (Backbone, $, router, site_vars) {
    //
    // Lien interne
    //

    var InternalFormView = Backbone.View.extend({
        events: {
            'submit': 'sumbitf',
        }, initialize:function(){
          alert("h");
        },
        submitf:function (e) {
            e.preventDefault();
            alert("z");
        },

    });


    //
    // Static method
    // Permet d'initializer les liens d'un context jQuery
    // retourne un tableau de InternalLinkView
    //
    InternalFormView.initializeForms = function(jqueryContext){
        var forms = [];
        jqueryContext.not('.ignore-ajax').each(function(){
            // si le lien est déjà linké, on ne créé pas de nouvelle vue
            forms.push(new InternalFormView({el:this}));
        });
        return forms;
    };

    // 
    // Static method
    // permet d'initialiser tous les liens d'une vue
    //
    InternalFormView.initializeFormsOfView = function(view){
        var forms = InternalFormView.initializeForms($('.simple-cta-form'));
        view.attachViews(forms);
        return forms;
    };

    //
    // Static method
    // permet d'initialiser tous les liens d'un élement HTML
    //
    // InternalLinkView.initializeLinksOfEl = function(el){
    //     return InternalLinkView.initializeLinks($('a[href^="'+router.getBaseUrl()+'"], a[href^="/"]',el))
    // };
    
    return InternalFormView;
});
